// import chatBotImage from '../assets/image/Tax1099.svg';
import socket from '../socket';
import shortenUrl from './shortenUrl';

let message = '';
let streamedMessage = '';
let sourceId = '';
let arrowId = '';
let clarifyId = '';
const clientType = process.env.REACT_APP_CLIENT;

// Function to handle "Learn more" button click
function handleLearnMoreClick() {
  // Your custom logic when the "Learn more" button is clicked
  const sourcesElem = document.querySelector(`#${sourceId}`);
  const arrowElem = document.querySelector(`#${arrowId}`);

  sourcesElem && sourcesElem.classList.toggle('hidden');
  arrowElem && arrowElem.classList.toggle('rotate-180');
}

function getTimeStamp() {
  const now = new Date();
  const hours = now.getHours() % 12 || 12; // .toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const period = now.getHours() >= 12 ? 'PM' : 'AM';
  const timeStamp = `${hours}:${minutes} ${period}`;
  return timeStamp;
}

function renderMesssage(username: string, msg: string, sources?: any) {
  // src="/static/media/Tax1099.2142caaa87783a2c247ea59404161f3a.svg"
  if (username === 'Chat Bot') {
    return `<div class="flex w-full mt-2 space-x-3 max-w-5xl">
    
    <div className="taxLogo-bg">
      <div className="bg-no-repeat bg-center taxLogo"></div>
    </div>
    <div class="text-start">
      <div class="bg-gray-300 rounded-r-lg rounded-bl-lg">
      <div class="p-3">
        <p class="text-sm whitespace-pre-line typing__dot">${msg}</p>
      </div>        
      ${
        sources && sources.length > 0
          ? `
          <div class="border-t border-black">
            <div class="px-3 py-1">
              <button id="learnMoreButton" class="flex items-center">
                <strong>Learn more:</strong>
                <div class="transition-opacity" id="${arrowId}">
                  <svg
                    class="w-5 h-5 p-1 mx-1 text-gray-700 dark:text-gray border border-gray-700 rounded-full transform"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 8"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="0.9"
                      d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1"
                    />
                  </svg>
                </div>
              </button>
              <div class="flex flex-col hidden" id="${sourceId}">
                ${sources.map(
                  (source: any, index: number) => `
                    <div class="inline-flex">
                      <p>${index + 1}.</p>
                      <a 
                        target="_blank"
                        href="https://www.tax1099.com"
                        class="inline-block max-w-xs overflow-hidden text-ellipsis mx-1 rounded text-blue-700 hover:underline"
                      >
                        ${
                          source &&
                          source[0] &&
                          source[0].source &&
                          shortenUrl(source[0].source)
                        }
                      </a>
                    </div>
                `,
                )}
              </div>
            </div>
          </div>`
          : ``
      }
      </div>
      <span class="text-xs text-gray-500 leading-none text-start text-[12px]">
        ${getTimeStamp()}
      </span>
    </div>
  </div>`;
  }
  return `
    <div class="flex w-full mt-2 space-x-3 max-w-5xl ml-auto justify-end">
    <div class="w-10 h-10 min-w-10 bg-blue-900 text-white ml-2 flex items-center justify-center rounded-full text-xl font-semibold order-last" style="min-width: 2.5rem">
  U
  </div>
      <div class="text-end">
        <div class="bg-blue-900 text-white p-3 rounded-l-lg rounded-br-lg">
          <p class="text-sm text-left whitespace-pre-line typing__dot">${msg}</p>
        </div>
        <span class="text-xs text-gray-500 leading-none text-start text-[12px]">
          ${getTimeStamp()}
        </span>
      </div>
    </div>  
  `;
}

export function updateChatConversation(
  username: string,
  data: any,
  divId = null,
) {
  const messageContainer = document.querySelector('#bterai-container');
  if (username === 'Chat Bot') {
    const messageBox = document.querySelector(`#${divId}`);
    if (!messageBox) {
      message = data;
      const newMsgBox = document.createElement('div');
      if (divId) newMsgBox.setAttribute('id', divId);
      newMsgBox.setAttribute('class', 'flex flex-col flex-grow');
      if (newMsgBox) {
        newMsgBox.innerHTML = renderMesssage(username, message);
      }
      messageContainer?.appendChild(newMsgBox);
    } else {
      message += data;
      messageBox.innerHTML = renderMesssage(username, message);
      messageContainer?.appendChild(messageBox);
    }
  } else {
    message = data;
    const newMsgBox = document.createElement('div');
    if (divId) newMsgBox.setAttribute('id', divId);
    newMsgBox.setAttribute('class', 'flex flex-col flex-grow');
    if (newMsgBox) {
      newMsgBox.innerHTML = renderMesssage(username, message);
    }
    messageContainer?.appendChild(newMsgBox);
  }
}

export function updateChatStreamConversation(
  username: string,
  data: any,
  divId = null,
  sources: any,
) {
  const messageContainer = document.querySelector('#bterai-container');
  if (username === 'Chat Bot' && divId !== null) {
    const messageBox = document.querySelector(`#${divId}`);
    if (!messageBox) {
      streamedMessage = data;
      const newMsgBox = document.createElement('div');
      sourceId = `${divId}-sources`;
      arrowId = `${divId}-arrow`;
      newMsgBox.setAttribute('id', divId);
      newMsgBox.setAttribute('class', 'flex flex-col flex-grow');
      if (newMsgBox) {
        newMsgBox.innerHTML = renderMesssage(
          username,
          streamedMessage,
          sources,
        );
      }
      messageContainer?.appendChild(newMsgBox);
    } else {
      streamedMessage += data;
      messageBox.innerHTML = renderMesssage(username, streamedMessage, sources);
      messageContainer?.appendChild(messageBox);
      // Add the event listener after rendering the message
      const learnMoreButton = document.getElementById('learnMoreButton');
      if (learnMoreButton) {
        learnMoreButton.addEventListener('click', handleLearnMoreClick);
      }
    }
  }
}

export function renderSources(sourceObj: any, divId: string) {
  if (sourceObj && sourceObj.length > 0) {
    // const chatBox = document.querySelector(`#${divId}-chat-box`);
    const sourceList = document.querySelector(`#${divId}-source-list`);
    // sourceList.addC
    // sourceList && sourceList.setAttribute('class', 'border-t border-black');

    if (sourceList) {
      sourceId = `${divId}-sources`;
      arrowId = `${divId}-arrow`;
      // const template = `
      //   <div class="px-3 py-1">
      //     <button id="${divId}-learnMoreButton" class="flex items-center">
      //       <strong>Learn more:</strong>
      //       <div class="transition-opacity" id="${arrowId}">
      //         <svg
      //           class="w-5 h-5 p-1 mx-1 text-gray-700 dark:text-gray border border-gray-700 rounded-full transform"
      //           aria-hidden="true"
      //           xmlns="http://www.w3.org/2000/svg"
      //           fill="none"
      //           viewBox="0 0 14 8"
      //         >
      //           <path
      //             stroke="currentColor"
      //             strokeLinecap="round"
      //             strokeLinejoin="round"
      //             strokeWidth="0.9"
      //             d="m1 1 5.326 5.7a.909.909 0 0 0 1.348 0L13 1"
      //           />
      //         </svg>
      //       </div>
      //     </button>
      //     <div class="flex flex-col hidden" id="${sourceId}">
      //       ${sourceObj.map(
      //         (source: any, index: number) => `
      //           <div class="inline-flex">
      //             <p>${index + 1}.</p>
      //             <a 
      //               target="_blank"
      //               href="${
      //                 source &&
      //                 source.length > 0 &&
      //                 source[0] &&
      //                 source[0].source
      //               }"
      //               class="inline-block max-w-xs overflow-hidden text-ellipsis mx-1 rounded text-blue-700 hover:underline"
      //             >
      //               ${
      //                 source &&
      //                 source[0] &&
      //                 source[0].source &&
      //                 shortenUrl(source[0].source)
      //               }
      //             </a>
      //           </div>
      //       `,
      //       )}
      //     </div>
      //   </div>
      // `;
      // sourceList.innerHTML = template;

      const learnMoreButton = document.getElementById(
        `${divId}-learnMoreButton`,
      );
      if (learnMoreButton) {
        learnMoreButton.addEventListener('click', handleLearnMoreClick);
      }
    }
  }
}

export function renderClarifyingQuestions(
  questionsArray: any,
  divId: string,
  userId: string
) {
  if (!questionsArray || questionsArray.length === 0) return;
  clarifyId = `${divId}-clarify-list`
  const targetDiv = document.querySelector(`#${clarifyId}`);
  if (!targetDiv) {
    console.warn("Clarify-list container not found for divId", divId);
    return;
  }

  targetDiv.innerHTML = "";

  targetDiv.setAttribute("class", "flex flex-wrap gap-2 px-3 py-2");

  const questions = Array.isArray(questionsArray[0])
    ? questionsArray[0]
    : questionsArray;

  questions.forEach((question: string) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.textContent = question;
    btn.className =
      `px-2 py-2 bg-white border-[1.5px]  rounded-lg text-md transition text-left
      ${clientType==='salesbot2290ai'? `border-[#1DBC9180] text-[#3fa0a0] hover:bg-[#e8f6f6]`:`border-[#185BA5] text-[#185BA5] hover:bg-[#E8EFF6]`}`;

    btn.addEventListener("click", () => {
      socket.emit("sendchat",  question , userId);
    });

    targetDiv.appendChild(btn);
  });
}